import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useCartReducer = () => useSelector((state: ApplicationState) => state.cart);
